<script>
  import lune from 'lune'
  import { _ } from 'svelte-i18n'

  import {styleVars, scaleValue} from '/helper'
  import Card from '/components/Atoms/Card.svelte'

  // TODO SSR: onMount()
  const moon = lune.phase(new Date())
  const phase = moon.phase

  console.log("moon", moon)

  //const phases = [0,0.1,0.2,0.3,0.4,0.5,0.6,0.7,0.8,0.9,1]
  const coords = [phase].map(p=>({
    left: (50 -  50 * Math.cos( Math.PI * scaleValue(p, [0,1], [0.2, 0.8]) )) +"%",
    top:  (50 + -50 * Math.sin( Math.PI * scaleValue(p, [0,1], [0.2, 0.8]) )) +"%"
  }))

  const terms = {
    new: $_("widgets.moon.terms.new"),
    full: $_("widgets.moon.terms.full")
  }

  const names = [
    $_("widgets.moon.phases.New Moon"),
    $_("widgets.moon.phases.Waxing Cescent"),
    $_("widgets.moon.phases.Quarter Moon"),
    $_("widgets.moon.phases.Waxing Gibbous"),
    $_("widgets.moon.phases.Full Moon"),
    $_("widgets.moon.phases.Waning Gibbous"),
    $_("widgets.moon.phases.Last Quarter"),
    $_("widgets.moon.phases.Waning Crescent"),
  ]

  const images = [
    "1_NewMoon.png",
    "2_WaxingCescent.png",
    "3_QuarterMoon.png",
    "4_WaxingGibbous.png",
    "5_FullMoon.png",
    "6_WaningGibbous.png",
    "7_LastQuarter.png",
    "8_WaningCrescent.png",
  ]

  let b = Math.round(phase * 8); // scale fraction from 0-8 and round
  if (b >= 8) b = 0; // 0 and 8 are the same so turn 8 into 0
  const name = names[b]

  const moonMaxAge = 29.53

  const daysTillNew = Math.floor(moonMaxAge - moon.age)
  const daysTillFull = Math.floor(( 0.5 * moonMaxAge) - moon.age)

  console.log(daysTillNew, daysTillFull)
</script>

<Card bgColorKey="beige" paddingStyle="moon">
  <div class="moon-container">
    <div class="circle">
      {#each coords as coord}
        <img src="assets/images/moon/{images[b]}" class="moon" alt={$_("widgets.moon.terms.moon")} style={styleVars({left: coord.left, top: coord.top})}/>
      {/each}
    </div>
  </div>

  <div class="content">
    <h3 class="title">{$_("widgets.moon.terms.moon_phase")}</h3>
    <span class="name">{name}</span>
    <span class="percentage">
      {#if daysTillFull >= 0}
        {terms.full}: -{daysTillFull}d
      {:else}
        {terms.new}: -{daysTillNew}d
      {/if}
    </span>
  </div>
</Card>

<style lang="scss">

  .content {
    @include typo-serif-text-28;
    height: 200px;
    display: grid;
    grid-template-rows: 1fr 1fr;
    grid-template-columns: 1fr 1fr;
    

    .title {
      grid-row: 1;
      grid-column: 1;
    }
    .name {
      grid-row: 2;
      grid-column: 1;
      align-self: end;
      
    }
    .percentage {
      grid-row: 2;
      grid-column: 2;
      justify-self: end;
      align-self: end;
    }
  }


  .moon-container {
    box-sizing: border-box;
    text-align: center;
    height: 230px;
    left:0; top:0; width: 100%; height: 100%;
    position: absolute;;
    overflow: hidden;
    mask-image: linear-gradient(black 60%, transparent 90%);
  
    .circle {
      border: solid $color-mint 2px;
      border-radius: 50%;
      position: absolute;
      width: 70%;
      left:15%;
      top:25%;
      height: 450px;
      box-sizing: border-box;

      img {
        position: absolute;
        top: var(--top);
        left: var(--left);
        transform: translateX(-50%) translateY(-50%);
        &.moon {
          width: 90px;
          height: 90px;
        }
      }
    }
  }

</style>